import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import type {ThemeTileProps} from './theme-tile.types';
import styles from './theme-tile.module.scss';

export function ThemeTile({option, onSelect}: ThemeTileProps): ReactElement {
  const handleClick = (): void => {
    onSelect(option.theme);
  };

  return (
    <ClickableDiv className={styles.tile} onClick={handleClick}>
      <div className={styles.tileImageContainer}>
        <img className={styles.tileImage} src={option.imageUrl} alt={window.i18next.t(option.label)} width={60} height={60} />
      </div>
      <Text val={window.i18next.t(option.label)} size={TextSize.SM} className="ct-neutral-primary" />
    </ClickableDiv>
  );
}
